<div
  class="td-wb-chart__content"
  highchartsChart
  [options]="chartOptions()"
  [constructorType]="type()"
  (chartInstance)="onChartInstance($event)">
</div>
